import { IVChat, IVChatMsg, IChat, IChatMsg, AppDatabase } from "../database/AppDatabase";
import { UserChatItem } from "../models/api/UserChatItem";
import { IMChat } from "../models/api/IMChat";
import { IMChatMsg } from "../models/app/IMChatMsg";
import { DbService } from "./interfaces/DbService";

class DexieDbImpl implements DbService {
    

    private readonly dexie = new AppDatabase()


    async getAllVChats(): Promise<UserChatItem[]> {

        //this.db.vChats.where('').
        return this.dexie.vChats.reverse().sortBy('lastChatTime')

    }
    getMsgsForVChat(id: string): Promise<IVChatMsg[]> {
        throw new Error("Method not implemented.");
    }
    getAllChats(): Promise<IChat[]> {
        
        return this.dexie.chats.reverse().sortBy('lastMsgTime')
    }

    getMsgsForChatter(uid: string): Promise<IMChat[]> {

        return this.dexie.chatMsgs
            .where('senderUid').equals(uid)
            .or('recepUid').equals(uid)
            .sortBy('timestamp')
        
        

    }

    createVChat(vChat: IVChat): Promise<void> {


        throw new Error("Method not implemented.");
    }
    async createChat(chat: IChat): Promise<void> {
        
        this.dexie.chats.put(chat)
    }

    async updateBulkVChat(vChats: UserChatItem[]): Promise<void> {
        let promiseList: Promise<any>[] = []
        vChats.forEach(item =>{
            promiseList.push(this.dexie.vChats.put(item))
        })

        await Promise.all(promiseList)

    }

    putVChatMsg(): Promise<void> {
        throw new Error("Method not implemented.");
    }
    async putChatMsg(chatMsg: IMChat): Promise<void> {
        this.dexie.chatMsgs.put(chatMsg, new Date(chatMsg.timestamp).getTime())
    }

    async deleteChat(chatterUid: string): Promise<void> {
        this.dexie.chats.delete(chatterUid)
    }
    async deleteChatMsgsForChatter(chatterUid: string): Promise<void> {
        this.dexie.chatMsgs.where('recepUid').equals(chatterUid)
            .or('senderUid').equals(chatterUid)
            .delete()
    }

    async destruct(){
        await this.dexie.delete()
        this.dexie.open()

    
    }

    async open(){
        await this.dexie.open()
    }


}

export const db: DbService = new DexieDbImpl()